import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    committeeTypList: [],
    rehabilitationTypList: [],
    caseTypeList: [],
    timeFormat: 'h:m',
    examTypeList: [],
    classList: [],
    schoolList: [],
    committeeNameList: [],
    committeeDesignationList: [],
    evaluationSettingList: [],
    courseList: [],
    instructorList: [],
    foodList: [],
    studentTypeList: Custom.studentTypeList,
    religionList: Custom.religionList,
    manpowerTypeList: Custom.manpowerTypeList,
    caseStatusList: Custom.caseStatusList,
    tenureTimeList: Custom.tenureTimeList,
    monthList: Custom.monthList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
